import type { Player } from "../../../common/types.ts";

// Annual experience is earned by regular-season MLB PA and BF, regardless of the
// player's current club or league level. It never subtracts development from a
// bench player or an injured player, and does not depend on WAR or team results.
export const majorLeagueExperienceEffect = (
	p: Pick<Player, "stats"> & { born: Pick<Player["born"], "year"> },
	season: number,
) => {
	const age = season - p.born.year;
	const ageFactor = Math.max(0, Math.min(1, (30 - age) / 5));
	if (ageFactor === 0) return 0;
	const workload = (p.stats ?? []).reduce((total: number, row: any) => {
		if (row.season !== season || row.playoffs || !(row.tid >= 0)) return total;
		const count = (value: number | undefined) =>
			Number.isFinite(value) ? Math.max(0, value!) : 0;
		return total + count(row.pa) + count(row.bf);
	}, 0);
	// Same saturation curve as minor league experience. The smaller positive-only
	// cap avoids the study's extra penalty for little playing time.
	return 0.2 * ageFactor * (1 - Math.exp(-workload / 250));
};
